import { NgModule } from '@angular/core';
import { FormatationDirective } from '../../directives/formatation.directive';
import { TimeFormatDirective } from '../../directives/timeFormat.directive';

const directves = [
  FormatationDirective,
  TimeFormatDirective
]


@NgModule({
  declarations: directves,
  imports: [
  ],
  exports: directves
})
export class DirectiveModule { }
